module.exports = __webpack_public_path__ + "dcef5592b4b3b20c3626e3fa33593001.svg";